import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { IP_INFO } from "src/app/constants/environment.constants";
import { Language } from "src/app/constants/language/language.constants";
import { HttpService } from "../http/http.service";

@Injectable()
export class LocalizationService {
    private language!: string;
    private _isKorean!: boolean;
    private _utcOffset!: string | null;

    constructor(private translateService: TranslateService, private httpService: HttpService) {
        this.checkClientCountryInfo();
    }

    private checkClientCountryInfo(): void {
        if (!this.language) {
            let language: string | null = localStorage.getItem("language");

            if (language) {
                this.language = language;
                this._isKorean = this.language == Language.KOREAN;
            }
        }

        if (!this._utcOffset) {
            let utcOffset: string | null = localStorage.getItem("utcOffset");

            if (utcOffset) {
                this._utcOffset = utcOffset;
            }
        }

        if (this.language && this._utcOffset) {
            this.setLanguage();
        } else {
            this.getClientCountryInfo();
        }
    }

    public getClientCountryInfo(): void {
        this.httpService.get<any>(IP_INFO, true)
            .subscribe(response => {
                try {
                    this.language = response.languages.toLowerCase().substring(0, 2);
                    this._utcOffset = response.utc_offset;
                } catch (error) {
                    this.language = Language.ENGLISH;
                    this._utcOffset = null;
                }

                this._isKorean = this.language == Language.KOREAN;
                localStorage.setItem("language", this.language);

                if (this._utcOffset) {
                    localStorage.setItem("utcOffset", this._utcOffset);
                }

                this.setLanguage();
            });
    }

    public getLanguage(): string {
        return this.language;
    }

    public setLanguage(): void {
        this.translateService.setDefaultLang(this.language);
    }

    public toggleLanguage(): void {
        this._isKorean = !this._isKorean;

        if (this._isKorean) {
            this.language = Language.KOREAN;
        } else {
            this.language = Language.ENGLISH;
        }

        localStorage.setItem("language", this.language);
        window.location.reload();
    }

    public translate(key: string): string {
        return this.translateService.instant(key);
    }

    public get isKorean(): boolean {
        return this._isKorean;
    }

    public get utcOffset(): string | null {
        return this._utcOffset;
    }
}